import { EventEmitter, Injectable } from '@angular/core'

@Injectable()
export class CoreBasicService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   public onEvent: EventEmitter<any> = new EventEmitter<any>()

   constructor() {}

   emitEvent(eName: string, eParams?: any, eType?: string) {
      if (eName) {
         let event = {
            type: eType || 'app',
            name: eName,
            params: eParams || null,
         }

         if (this.console) console.log(this.logPrefix, 'emitEvent:', event)

         this.onEvent.emit(event) // emit

         return true
      }
      return false
   }
}

